(function ($) {
    $(document).ready(function () {
        // Initialize Select2 dropdowns within #blog-filter
        $('#blog-filter select').select2({
            minimumResultsForSearch: Infinity, // Disables the search box for dropdowns
            width: '100%'
        });

        // Event listener for when dropdowns change
        $('#blog-filter select').on('change', function () {
            const selectedValue = $(this).val();
            const nextPageUrl = selectedValue;

            // 1. Add 'active' class to the relevant select2 container
            $('#blog-filter .select2-selection--single').removeClass('active'); // Remove active from all
            const currentSelect2Container = $(this)
                .next('.select2-container')
                .find('.select2-selection--single'); // Target current select2 container
            currentSelect2Container.addClass('active'); // Add active class

            // 2. Reset other dropdowns
            $('#blog-filter select').not(this).each(function () {
                $(this).val($(this).find('option:first').val()); // Reset to the first option
                $(this).trigger('change.select2'); // Update the Select2 UI only
            });

            // 3. AJAX Request to load content dynamically
            $.ajax({
                url: nextPageUrl,
                type: 'GET',
                beforeSend: function () {
                    // Add loading animation or indicator here if needed
                },
                success: function (response) {
                    const newPosts = $(response).find('.wp-block-post-template > *');
                    newPosts.addClass('observing');
                    $('.wp-block-st-project-details').remove();

                    $('ul.wp-block-post-template').empty().append(newPosts);

                    setTimeout(function () {
                        newPosts.addClass('intersected intersecting');
                    }, 250);

                    // Reinitialize event listeners for dynamically loaded .read-more-button
                    document
                        .querySelectorAll('.project-card-content-container .read-more-button')
                        .forEach((button) => {
                            button.addEventListener('click', function () {
                                const container = button.closest('.project-card-content-container');
                                if (container) {
                                    container.classList.toggle('active');
                                }
                            });
                        });
                },
            });
        });
    });
})(jQuery);
